import { preInitializeOfficeAddIn } from '../Root/Environment/Public/AddIn/OfficeAddin';

export function setupOfficeAddIn()
{
    return preInitializeOfficeAddIn();
}
